import { useFonts } from '@folklore/fonts';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import Modal from '../modals/Modal';
import Footer from './Footer';
import Header from './Header';

import styles from '../../../styles/layouts/main.module.scss';

const propTypes = {
    page: AppPropTypes.page,
    pageLoading: PropTypes.bool,
    children: PropTypes.node,
    fonts: PropTypes.shape({
        google: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
        custom: PropTypes.objectOf(PropTypes.arrayOf(PropTypes.string)),
    }),
};

const defaultProps = {
    page: null,
    pageLoading: false,
    children: null,
    fonts: {
        custom: {
            families: ['DIN Condensed', 'Inter'],
        },
        // google: {
        //     families: ['Poppins:300,400,500,600,700'],
        // },
    },
};

const MainLayout = ({ page, pageLoading, fonts, children }) => {
    useFonts(fonts);
    const { handle = null } = page || {};
    const isHeaderMinified = handle !== 'home';
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.floatingHeader]: !isHeaderMinified,
                    [styles.isPageLoading]: pageLoading,
                },
            ])}
        >
            <Header
                className={styles.header}
                pageLoading={pageLoading}
                minified={isHeaderMinified}
            />
            <main className={styles.content}>{children}</main>
            <Footer className={styles.footer} />
            <Modal page={page} />
            <div className={styles.loading} />
        </div>
    );
};

MainLayout.propTypes = propTypes;
MainLayout.defaultProps = defaultProps;

export default MainLayout;
